import React, { Component } from "react";
import { ReactSortable } from "react-sortablejs";
import Result from "./Result.jsx";
import "../style/exercices.css";
import { success, fail } from "../utils/coursesUtils.js";
import { withTranslation } from "react-i18next";
import { globalT } from "../utils/globalUtils.js";
import { useNavigate, useLocation } from "react-router-dom";

class ExDrag extends Component {
  constructor(props) {
    super(props);
    this.audioRef = React.createRef();
    this.state = {
      list: this.props.el.list,
      result: null,
      finished: false,
      soundType: "",
    };
  }

  checkResults = () => {
    const correct = this.state.list.every((item, i) => i === item.order);

    this.setState(
      (prevState) => {
        const updatedList = prevState.list.map((item, i) => ({
          ...item,
          resultClass: i !== item.order ? "m-incorrect" : "m-correct",
        }));
        return { result: correct, finished: true, list: updatedList };
      },
      () => {
        if (correct) {
          success(this);
        } else {
          fail(this);
        }

        const body = document.querySelector("#content");
        body.scrollTo(0, 0);
      }
    );
  };

  // componentDidUpdate(prevProps, prevState) {
  //   if (prevState.soundType !== this.state.soundType) {
  //     // Actualiza la referencia al elemento de audio cuando cambia soundType
  //     this.audioRef.current.src = `/sounds/${this.state.soundType}`;
  //   }
  // }

  render() {
    const { el, genre } = this.props;
    const { t } = this.props;
    const { list, result, finished } = this.state;
    return (
      <>
        <div className="m-breadcrumb">
          <div className="m-genre">{genre}</div>
          <div className="m-exTitle">{el.typeName}</div>
        </div>
        <div
          className={`m-exercice ${finished ? "finished" : ""}`}
          data-type="sort"
        >
          {finished && <Result result={result} />}
          {el.title && (
            <div
              className="m-title"
              dangerouslySetInnerHTML={{ __html: el.title }}
            ></div>
          )}
          {el.subtitle && (
            <div
              className="m-subtitle"
              dangerouslySetInnerHTML={{ __html: el.subtitle }}
            ></div>
          )}
          {el.title2 && (
            <div
              className="m-title"
              dangerouslySetInnerHTML={{ __html: el.title2 }}
            ></div>
          )}
          <div className="m-draggableOptions" id="draggableOptions">
            <ReactSortable
              list={list}
              setList={(newList) => this.setState({ list: newList })}
            >
              {list?.map((item) => (
                <div
                  className={`m-option ${item.resultClass}`}
                  data-id={item.id}
                  data-correct={item.order}
                  key={item.id}
                  dangerouslySetInnerHTML={{ __html: item.text }}
                ></div>
              ))}
            </ReactSortable>
          </div>
          {el.font && (
            <div className="m-font">
              <div>
                {globalT("FUENTE DEL TEXTO")}{" "}
                {el.adaptedSRC && <span>{`(${globalT("adaptado")})`}</span>}:
              </div>
              <a href={el.font} target="_blank" rel="noreferrer">
                {el.font}
              </a>
            </div>
          )}
          <div className="m-buttons">
            {finished ? (
              <button
                className="m-button"
                id="buttonBack"
                onClick={() => {
                  const path = this.props.location.pathname;
                  const parentPath = path.substring(0, path.lastIndexOf("/"));
                  this.props.navigate(parentPath + "/");
                }}
              >
                <span>{globalT("vuelve a las actividades")}</span>
              </button>
            ) : (
              <button className="m-button" onClick={this.checkResults}>
                <span>{globalT("Continúa")}</span>
              </button>
            )}
          </div>
          <audio ref={this.audioRef} src=""></audio>
        </div>
      </>
    );
  }
}

function ExDragWrapper(props) {
  const navigate = useNavigate();
  const location = useLocation();
  return <ExDrag {...props} navigate={navigate} location={location} />;
}

export default withTranslation()(ExDragWrapper);
